import { Link } from "react-router-dom";

interface DisclaimerProps {
  compact?: boolean;
  dark?: boolean;
}

const Disclaimer = ({ compact, dark }: DisclaimerProps) => {
  if (compact) {
    return (
      <p className={dark ? "text-xs text-alt-wht/50" : "text-xs text-alt-blk/55"}>
        Dates and camping rules change. Confirm on the official page.{" "}
        <Link
          to="/about"
          className={dark ? "text-ray hover:text-sunset" : "text-turquoise hover:text-mars"}
        >
          About
        </Link>
      </p>
    );
  }

  return (
    <p className="leading-relaxed">
      Seasons are curated from organizer calendars and can shift. A pin is not
      a hunting permit and not an invitation onto private land. Always confirm
      dates, tickets, and overnight rules before you roll.
    </p>
  );
};

export default Disclaimer;
